import React from 'react';
import { BudgetSummaryData } from '../types/budget';
import { FlagIcon } from 'lucide-react';
interface SummaryBarProps {
  data: BudgetSummaryData;
  totalConditions: number;
}
export function SummaryBar({
  data,
  totalConditions
}: SummaryBarProps) {
  const formatCurrency = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(val);
  const formatPercent = (val: number) => new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 2
  }).format(val / 100);
  return <div className="bg-primary text-white h-12 flex items-center justify-between px-6 text-sm w-full shrink-0 shadow-md z-10 relative" data-id="element-85">
      <div className="flex items-center gap-4 text-gray-300 font-body font-thin overflow-x-auto whitespace-nowrap hide-scrollbar" data-id="element-86">
        <span className="flex gap-1.5 items-center" data-id="element-87">
          <span className="text-white font-normal" data-id="element-88">
            {new Intl.NumberFormat('en-US').format(data.squareFootage)}
          </span>{' '}
          Sq Ft
        </span>
        <span className="w-px h-4 bg-white/20" data-id="element-89"></span>
        <span className="flex gap-1.5 items-center" data-id="element-90">
          <span className="text-white font-normal" data-id="element-91">
            {formatPercent(data.percentCompleteAfterRough)}
          </span>{' '}
          Complete
        </span>
        <span className="w-px h-4 bg-white/20" data-id="element-92"></span>
        <span className="flex gap-1.5 items-center" data-id="element-93">
          <span className="text-white font-normal" data-id="element-94">
            {formatPercent(data.softCostPercent)}
          </span>{' '}
          Soft Cost
        </span>
        <span className="w-px h-4 bg-white/20" data-id="element-95"></span>
        <span className="flex gap-1.5 items-center" data-id="element-96">
          <span className="text-white font-normal" data-id="element-97">
            {formatCurrency(data.totalBudget)}
          </span>{' '}
          Budget
        </span>
        <span className="w-px h-4 bg-white/20" data-id="element-98"></span>
        <span className="flex gap-1.5 items-center" data-id="element-99">
          <span className="text-white font-normal" data-id="element-100">
            {formatCurrency(data.constructionEscrow)}
          </span>{' '}
          Escrow
        </span>
        <span className="w-px h-4 bg-white/20" data-id="element-101"></span>
        <span className="flex gap-1.5 items-center" data-id="element-102">
          <span className="text-white font-normal" data-id="element-103">
            {formatCurrency(data.totalBudget - data.constructionEscrow)}
          </span>{' '}
          Shortfall
        </span>
      </div>
      <div className="flex items-center gap-2 font-body font-normal bg-white/10 px-3 py-1 rounded-full shrink-0 ml-4" data-id="element-104">
        <FlagIcon className="w-4 h-4 text-accent-1" data-id="element-105" />
        <span data-id="element-106">{totalConditions} Conditions</span>
      </div>
    </div>;
}